export default class QT_TramQT {
    constructor(item) {
        this.id = item.id
        this.diaDiem = item.diaDiem
        this.doiTuongQuanTrac = item.doiTuongQuanTrac
        this.donViQuanLy = item.donViQuanLy
        this.hangTram = item.hangTram
        this.kinhTuyenTruc = item.kinhTuyenTruc
        this.maHuyen = item.maHuyen
        this.maTinh = item.maTinh
        this.maXa = item.maXa
        this.muiChieu = item.muiChieu
        this.namSuDung = item.namSuDung
        this.namXayDung = item.namXayDung
        this.phanLoaiQuanTrac = item.phanLoaiQuanTrac
        this.soGieng = item.soGieng
        this.soHieu = item.soHieu
        this.song = item.song
        this.tenDVHC = item.tenDVHC
        this.tenLuuVucSong = item.tenLuuVucSong
        this.tenTram = item.tenTram
        this.toaDo = item.toaDo
        this.loai_KTT = item.loai_KTT
        this.ten_KTT = item.ten_KTT
        this.loaiTram = item.loaiTram
        this.tpmT_Ma = item.tpmT_Ma
        this.thuocSong = item.thuocSong
        this.thuocLVS = item.thuocLVS
        this.thongTinChung_Id = item.thongTinChung_Id
        this.idGiayPhep = item.idGiayPhep
        this.tenDoanhNghiep = item.tenDoanhNghiep
        this.diaChi_DN = item.diaChi_DN
        this.diaChiDVXCP = item.diaChiDVXCP
        this.tenDonViXCP = item.tenDonViXCP
    }
}